<template>
  <div class="page-container">
    <!-- header -->
    <el-card>
      <el-row class="top_row" :gutter="20">
        <el-col :span="6">
          <el-input
            placeholder="请输入关键字搜索"
            class="input-with-select"
            clearable
            v-model="queryInfo.keyword"
            @clear="adInfopageFn"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="adInfopageFn"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="8" >
          <el-button type="primary" size="mini" @click="createAd('create')"
          >新增广告
          </el-button
          >
        </el-col>
      </el-row>
      <el-row>
      </el-row>
    </el-card>
    <!-- body -->
    <el-card>
      <vxe-table
        resizable
        ref="lockTable"
        align="center"
        :data="lockInfoList"
        :loading="loading"
      >
      <vxe-column type="checkbox" width="60"></vxe-column>
        <vxe-column type="seq" width="50" title="序号"></vxe-column>
        <vxe-column field="title" title="广告标题"></vxe-column>
        <vxe-column field="createTime" title="创建时间"></vxe-column>
        <vxe-column title="是否为首页轮播" width="150">
            <template #default="{ row }">
              <el-switch
              v-if="row.adType !== 4"
              :value="row.isHomePage"
              :active-value="1"
              :inactive-value="0"
              @change="switchAdStatus(row)"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="启用"
              inactive-text="禁用"
            >
            </el-switch>
            </template>
         </vxe-column>
         <vxe-column field="remarks" title="备注"></vxe-column>
         <vxe-column title="操作" width="300">
            <template #default="{ row }">
              <el-button
                  type="warning"
                  size="mini"
                  @click="createAd('edit',row)"
                  >编辑</el-button
                >
                <el-button
                @click="deleteAd(row.id)"
                  type="danger"
                  size="mini"
                  >删除广告</el-button
                >
            </template>
         </vxe-column>
      </vxe-table>
    </el-card>
    <base-pagination
      :total="total"
      :currentPage="queryInfo.pageNum"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></base-pagination>
    <edit-advertising :addData="addData" @successHandle="successHandle"></edit-advertising>
  </div>
</template>

<script>
import editAdvertising from './dialog/editAdvertising.vue'
import { adInfopage, setHomeAd, cancelHomeAd, adInfoDel } from '@/api/adv'
export default {
  data () {
    return {
      loading: false,
      addData: {
        id: '',
        title: '',
        type: '',
        adType: '',
        isOpen: false
      },
      queryInfo: {
        isHomePage: '',
        pageNum: 1,
        pageSize: 10,
        keyword: ''
      },
      lockInfoList: [],
      orgaInfoList: [],
      total: 0
    }
  },
  components: {
    editAdvertising
  },
  created () {
    this.adInfopageFn()
  },
  methods: {
     // 获取广告列表
    adInfopageFn () {
      this.loading = true
      adInfopage(this.queryInfo).then((res) => {
        this.loading = false
        this.lockInfoList = res.data.list
        this.total = res.data.total
      })
    },
    // 改变分页条目
    handleSizeChange (size) {
      this.queryInfo.pageNum = 1
      this.queryInfo.pageSize = size
      this.adInfopageFn()
    },
    // 改变页数
    handleCurrentChange (page) {
      this.queryInfo.pageNum = page
      this.adInfopageFn()
    },
    // 新增广告
    createAd (type, item) {
      this.addData.isOpen = true
      this.addData.type = type
      if (type === 'create') {
        this.addData.id = ''
        this.addData.title = '新增广告'
      } else {
        this.addData.id = item.id
        this.addData.title = '编辑广告'
      }
    },
    // 删除广告
    deleteAd (val) {
      this.$confirm('此操作将永久删除该版本, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const da = {
            id: val
          }
          adInfoDel(da).then((res) => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.adInfopageFn()
          })
        })
        .catch(() => {
          this.$message({
            type: 'warning',
            message: '已取消删除'
          })
        })
    },
    // 设置广告是否为首页轮播
    switchAdStatus (row) {
      const data = {
        id: row.id
      }
      console.log(row.isHomePage)
      if (row.isHomePage === 0) {
        setHomeAd(data).then(() => {
          this.adInfopageFn()
        })
      } else {
        cancelHomeAd(data).then(() => {
          this.adInfopageFn()
        })
      }
    },
    // 监听成功添加与编辑
    successHandle () {
      this.$refs.lockTable.clearCheckboxRow()
      this.adInfopageFn()
    }
  }
}
</script>

<style lang="scss" scoped>
.top_row {
  display: flex;
  align-items: center;
}
</style>
